/**
 * 한국어 조사 (DESIGN_SPEC 8장, 프로토타입 josa()).
 *
 * 이름 끝 글자의 받침으로 고릅니다. 한글이 아닌 글자로 끝나면 받침이 없는 쪽을 씁니다.
 */
const HANGUL_FIRST = 0xac00;
const HANGUL_LAST = 0xd7a3;
const FINAL_CONSONANT_COUNT = 28;
// ㄹ 받침. '으로/로' 에서만 받침이 없는 쪽처럼 씁니다 (서울로, 길로).
const RIEUL_INDEX = 8;

function finalConsonantIndex(word) {
    if (!word) {
        return 0;
    }
    const code = word.charCodeAt(word.length - 1);
    if (code < HANGUL_FIRST || code > HANGUL_LAST) {
        return 0;
    }
    return (code - HANGUL_FIRST) % FINAL_CONSONANT_COUNT;
}

export function hasFinalConsonant(word) {
    return finalConsonantIndex(word) !== 0;
}

/**
 * 이름에 조사를 붙입니다.
 *
 * @example withJosa('하린', '이는', '는') // '하린이는'
 * @example withJosa('지수', '이는', '는') // '지수는'
 * @example withJosa('도 대표', '과', '와') // '도 대표와'
 */
export function withJosa(word, withFinal, withoutFinal) {
    return word + (hasFinalConsonant(word) ? withFinal : withoutFinal);
}

/** '으로/로'. ㄹ 받침은 '로'를 씁니다. */
export function withEuro(word) {
    const index = finalConsonantIndex(word);
    if (index === 0 || index === RIEUL_INDEX) {
        return `${word}로`;
    }
    return `${word}으로`;
}
